// The Mira brand lockup, straight from Figma ("Mira logo full" 28:548 / "Mira
// logo solo" 28:569). Inline SVG rather than an <img src>: the brief export
// renders with NO network, so an asset URL would come out blank on paper.
//
// The wordmark and the "by fiverr." sub-mark paint in `currentColor` so the mark
// inverts with the theme (the Figma ink, Brand Grey/Black #222325, would vanish
// on a dark surface). The dot over the "i" keeps its fixed Fiverr mint: it is
// brand, not the client's `--brand` accent, so it must not re-tint per client.
// The same geometry is mirrored server-side for the standalone brief export in
// `backend/recruiter/export/brand.py` (that HTML is built without React).

const MIRA_MINT = "#98C7A4";

// One geometry, two crops: the solo variant is the same wordmark + dot with the
// "by fiverr." band cropped off the bottom of the viewBox.
const VIEW_BOX = {
  full: "0 0 973 483.301",
  solo: "0 0 973 336.215",
} as const;

const WORDMARK_PATH =
  "M831.267 110.215C890.026 110.215 929.802 145.923 936.13 202.875L946.074 286.495C949.69 " +
  "317.683 969.578 309.095 969.578 321.299C969.578 331.695 947.882 334.408 926.187 " +
  "334.408C900.423 334.408 888.67 329.435 885.958 309.999C876.014 324.915 857.03 336.215 " +
  "825.843 336.215C777.027 336.215 740.866 313.163 740.866 267.963C740.414 222.763 778.383 " +
  "199.259 822.679 199.259C843.47 199.259 860.194 204.683 871.946 212.819L871.494 " +
  "207.395C866.07 154.511 858.838 129.2 831.267 129.2C795.107 129.2 805.502 187.055 771.603 " +
  "187.055C755.331 187.055 744.483 177.111 744.482 161.743C744.482 129.199 784.259 110.215 " +
  "831.267 110.215ZM66.4443 112.023C76.8401 106.599 82.2635 112.926 82.2637 " +
  "121.514V142.758C95.3716 122.87 117.972 110.214 144.64 110.214C176.732 110.214 204.304 " +
  "124.227 219.672 150.895C231.876 125.131 258.092 110.214 288.376 110.214C329.508 110.214 " +
  "367.024 133.719 372.448 207.395L377.872 287.851C379.228 307.739 394.144 311.355 394.144 " +
  "322.655V324.462C394.144 329.434 390.076 332.147 384.2 332.147H306.004C299.676 332.147 " +
  "295.608 329.434 295.608 324.462V322.655C295.608 311.355 312.784 307.738 311.428 " +
  "288.302L306.908 205.586C304.648 154.51 291.54 135.979 267.584 135.979C246.34 135.979 " +
  "231.876 155.867 230.972 182.987C232.328 189.767 232.78 196.999 232.78 " +
  "204.683V288.302C232.78 307.738 248.6 311.355 248.6 322.655V324.462C248.6 329.434 244.532 " +
  "332.147 238.656 332.147H160.46C154.584 332.147 150.064 329.434 150.064 " +
  "324.462V322.655C150.064 311.355 166.336 307.738 166.336 288.302V200.162C166.336 158.126 " +
  "150.064 135.979 127.012 135.979C102.152 135.979 88.1396 157.675 88.1396 " +
  "186.151V288.302C88.1396 307.738 107.576 311.355 107.576 322.655V324.462C107.576 329.434 " +
  "103.508 332.147 97.1797 332.147H13.1084C7.2324 332.147 2.71191 329.434 2.71191 " +
  "324.462V322.655C2.71191 311.355 22.1484 307.738 22.1484 288.302V182.987C22.1484 163.099 0 " +
  "160.838 0 149.538V147.731C0 143.211 4.06819 140.951 9.49219 138.239L66.4443 " +
  "112.023ZM482.323 112.023C493.623 106.599 500.855 112.927 500.855 121.063V287.851C500.856 " +
  "307.286 519.839 310.903 519.839 322.202V324.01C519.839 328.53 515.771 331.695 509.443 " +
  "331.695H426.275C420.399 331.695 416.331 328.53 416.331 324.01V322.202C416.331 310.903 " +
  "433.507 307.286 433.507 287.851V185.699C433.507 165.811 416.332 160.839 416.331 " +
  "150.895V149.538C416.331 145.47 419.947 143.21 425.823 140.046L482.323 112.023ZM606.566 " +
  "112.023C616.962 107.051 621.03 112.475 621.03 121.063V154.962C630.974 126.034 652.218 " +
  "110.214 682.502 110.214C709.17 110.214 724.086 128.294 724.086 151.346C724.086 170.33 " +
  "716.854 187.054 695.158 187.054C659.902 187.054 675.722 148.183 651.314 148.183C633.686 " +
  "148.183 627.358 173.043 627.358 197.903V288.302C627.358 307.286 649.958 310.902 649.958 " +
  "322.202V324.01C649.958 328.982 645.89 331.695 640.014 331.695H556.394C550.066 331.695 " +
  "545.998 328.982 545.998 324.01V322.202C545.998 310.902 563.626 307.286 563.626 " +
  "288.302V182.534C563.626 162.647 542.834 161.29 542.834 149.991V148.183C542.834 143.663 " +
  "546.45 140.046 552.326 137.334L606.566 112.023ZM840.759 219.599C821.775 219.599 807.763 " +
  "234.515 807.763 257.567C807.763 288.755 822.678 316.327 845.73 316.327C866.522 316.327 " +
  "879.178 295.987 877.822 275.647L876.467 259.827C873.755 233.16 859.291 219.599 840.759 " +
  "219.599Z";

const BY_FIVERR_PATHS = [
  "M961.446 440.17C958.277 440.17 955.678 441.411 953.3 443.562C951.134 445.764 949.921 " +
    "448.731 949.925 451.817C949.925 454.874 951.058 457.473 953.318 459.851C955.696 462.111 " +
    "958.295 463.244 961.464 463.244C964.633 463.244 967.231 462.111 969.606 459.851C971.757 " +
    "457.473 972.999 454.874 972.999 451.817C973.014 450.29 972.725 448.778 972.151 " +
    "447.363C971.577 445.948 970.725 444.663 969.653 443.58C968.581 442.498 967.304 441.639 " +
    "965.892 441.05C964.485 440.466 962.972 440.166 961.446 440.166V440.17Z",
  "M949.929 420.265H940.072C933.738 420.265 930.345 425.012 930.345 " +
    "432.93V461.545H911.685V420.265H903.77C897.436 420.265 894.043 425.012 894.043 " +
    "432.93V461.545H875.379V404.998H894.043V413.592C897.097 406.922 901.28 404.998 907.502 " +
    "404.998H930.349V413.592C933.406 406.922 937.589 404.998 943.808 " +
    "404.998H949.937V420.269L949.929 420.265ZM871.301 437.691H832.393C833.41 444.025 837.37 " +
    "447.645 844.044 447.645C849.021 447.645 852.525 445.613 853.659 441.99L870.171 " +
    "446.628C866.1 456.485 856.034 462.462 844.047 462.462C823.803 462.462 814.527 446.74 " +
    "814.527 433.28C814.527 419.821 822.669 404.211 842.914 404.211C864.404 404.211 871.528 " +
    "420.276 871.528 432.147C871.528 434.742 871.427 436.439 871.301 437.691ZM853.207 " +
    "426.737C852.756 421.875 849.248 417.349 842.914 417.349C837.031 417.349 833.526 419.951 " +
    "832.396 426.737H853.207ZM781.971 461.549H798.368L818.84 404.998H800.064L790.11 " +
    "437.911L779.931 404.998H761.271L781.971 461.549ZM705.511 " +
    "461.549H724.06V420.269H741.705V461.549H760.142V404.998H724.06V401.493C724.06 397.646 " +
    "726.777 395.285 731.072 395.285H741.705V380H728.019C714.556 380 705.508 388.254 705.508 " +
    "400.36V404.998H694.99V420.269H705.508V461.549H705.511Z",
  "M575.673 452.608V460.859H565V382.201H575.673V413.555C578.863 408.163 585.573 404.532 " +
    "593.163 404.532C610.105 404.532 619.677 416.634 619.677 433.136C619.677 449.637 610.105 " +
    "461.739 593.055 461.739C585.685 461.739 578.863 458.108 575.673 452.608ZM608.896 " +
    "433.136C608.896 421.586 602.075 413.884 591.846 413.884C581.617 413.884 574.796 421.586 " +
    "574.796 433.136C574.796 444.685 581.505 452.388 591.846 452.388C602.187 452.388 608.896 " +
    "444.685 608.896 433.136Z",
  "M671.607 405.412L652.135 458.877L643.772 483.301H633.54L641.022 461.407L620.449 " +
    "405.412H631.45L645.97 446.995L660.599 405.412H671.6H671.607Z",
];

export type MiraLogoVariant = keyof typeof VIEW_BOX;

export type MiraLogoProps = {
  // "full" carries the "by fiverr." sub-mark; "solo" is the wordmark alone, for
  // slots too small to render the sub-mark legibly.
  variant?: MiraLogoVariant;
  className?: string;
  // Accessible name. Omit to render the mark decoratively (aria-hidden) when an
  // adjacent element already names the brand.
  title?: string;
};

export function MiraLogo({ variant = "full", className, title }: MiraLogoProps) {
  return (
    <svg
      className={className}
      viewBox={VIEW_BOX[variant]}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...(title ? { role: "img", "aria-label": title } : { "aria-hidden": true })}
    >
      <path d={WORDMARK_PATH} fill="currentColor" />
      {variant === "full"
        ? BY_FIVERR_PATHS.map((d) => <path key={d.slice(0, 24)} d={d} fill="currentColor" />)
        : null}
      <circle cx="458.5" cy="42.5" r="42.5" fill={MIRA_MINT} />
    </svg>
  );
}
